import { render } from "./appmenu.vue?vue&type=template&id=261b87bd"
import script from "./appmenu.vue?vue&type=script&lang=js"
export * from "./appmenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__